import { AuthForm } from "comps";

const Reset = () => <AuthForm mode="reset-password" />;

export default Reset;
